<template>
  <div
    v-click-outside="closeSelect"
    class="ui-select"
    :class="[{'is-error': error}]"
  >
    <div v-if="props.label" class="ui-select__label">
      {{ label }}
    </div>
    <div class="ui-select__input-container">
      <button
        class="ui-select__field"
        :class="[{open}]"
        @click="toggleOpen"
      >
        <span class="ui-select__field-value">
          <span v-if="!!current" class="text ui-select__field-name">{{
            current.text
          }}</span>
          <span v-else class="ui-select__field-placeholder text"
            >Не выбрано</span
          >
        </span>
        <span class="ui-select__field-arrow">
          <ArrowIcon />
        </span>
      </button>
      <div v-show="open" class="ui-select__drop">
        <div class="ui-select__drop-scroll">
          <div
            v-for="option in opts"
            :key="option.value"
            class="ui-select__drop-option"
            :class="{'is-active': option.id === current?.id}"
            @click="chooseOption(option)"
          >
            <div class="ui-select__drop-name">
              {{ option.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="error" class="text ui-select__error">
      {{ error }}
    </div>
  </div>
</template>

<script setup lang="ts">
import {onBeforeMount, watch} from 'vue';
import ArrowIcon from '~/assets/svg/arrowtobottom.svg';
import {useSelect} from '~/hooks/ui/useSelect';
import type {TSelectOption} from '~/interfaces/ui/select';

type Props = {
  options: Array<TSelectOption>;
  label?: string;
  error?: string;
  required?: boolean;
  description?: string;
  modelValue: object | string | number | null;
  returnObject?: boolean;
};

const props = defineProps<Props>();
const emit = defineEmits(['focus', 'change', 'update:modelValue']);

const {
  closeSelect,
  chooseOption,
  toggleOpen,
  opts,
  open,
  current,
  setOptions,
} = useSelect(props, emit);

onBeforeMount(() => setOptions());
watch(
  () => props.options,
  () => setOptions(),
);
</script>

<style scoped lang="scss">
.ui-select {
  width: 100%;
  position: relative;

  &__field {
    width: 100%;
    background: #f4f6fd;
    border: 1.5px solid #e1e5f0;
    border-radius: 8px;
    color: #3d424a;
    font-size: 16px;
    font-weight: 400;
    outline: none;
    padding: 11px 16px;
    display: flex;
    justify-content: space-between;
  }

  &__drop-scroll {
    box-shadow: 0 0 12px rgba(0, 0, 0, 0.04),
      0 12px 24px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    background: #fff;
    position: absolute;
    top: 100%;
    margin-top: 8px;
    padding-top: 8px;
    padding-bottom: 8px;
    left: 0;
    right: 0;
    z-index: 11;
  }

  &__drop-option {
    padding-left: 16px;
    padding-right: 16px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    cursor: pointer;

    &.is-active {
      color: #3e9eea;
    }
  }
}
</style>
